module.exports = __webpack_public_path__ + "static/media/Dialogs_Artwork.87c41277.jpg";